import CreateProjectForm from "../../components/CreateProjectForm/CreateProjectForm";

export default function CreateProject() {
  return <CreateProjectForm />;
}
